export const ORGANISATION_PLANS = [
  { value: 'starter', label: 'Starter' },
  { value: 'plus', label: 'Plus' },
  { value: 'bespoke', label: 'Bespoke' },
  { value: 'legacy-starter', label: 'Legacy' },
  { value: 'legacy-pro', label: 'Legacy Pro' },
];

export const organisationPlanLabel = plan =>
  ORGANISATION_PLANS.find(({ value }) => value === plan)?.label ?? 'No plan';
